var map = {
	"./front/youtube/VideoModal": 53699,
	"./front/youtube/VideoModal.tsx": 53699,
	"./styles/front/youtube/VideoModal.module": 43220,
	"./styles/front/youtube/VideoModal.module.sass": 43220,
	"components/front/youtube/VideoModal": 53699,
	"components/front/youtube/VideoModal.tsx": 53699,
	"components/styles/front/youtube/VideoModal.module": 43220,
	"components/styles/front/youtube/VideoModal.module.sass": 43220
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 88715;